const t = {
  down: 0,
  up: 180,
  left: -90,
  right: 90
}, O = {
  end: 0,
  forward: 0,
  start: 180,
  backwards: 180
};
export {
  t as ROTATE_CONVERSION,
  O as ROTATE_PAGINATION_CONVERSION
};
//# sourceMappingURL=index.es2479.js.map
